import { Injectable } from "@angular/core";
import { from, Observable, of, Subject, Subscription } from "rxjs";
import { EstatusJSON } from "../../../../shared/models/EstatusJSON";
import { GeofencesAPIService } from "../../../../shared/services/API/GeofencesAPI.service";

@Injectable({
  providedIn: "root",
})
export class TerritoriesService {
  
   isVisiblePanelTerritories$: Subject<boolean> = new Subject<boolean>();
   isVisiblePanelAddTerritories$: Subject<boolean> = new Subject<boolean>();
   isVisiblePanelEditTerritories$: Subject<boolean> = new Subject<boolean>();
   isVisiblePanelDetailTerritories$: Subject<boolean>= new Subject<boolean>();

   private isLoading$: Subject<boolean> = new Subject();

  public Result;

  constructor(private territoriesAPIService: GeofencesAPIService) {
  }

  setVisiblePanelTerritories(resp){
    this.isVisiblePanelTerritories$.next(resp);
  }

  getVisiblePanelTerritories(): Observable<boolean> {
    return this.isVisiblePanelTerritories$.asObservable();
  }

  setVisiblePanelDetailTerritories(resp){
    this.isVisiblePanelDetailTerritories$.next(resp);
  }

  getVisiblePanelDetailTerritories(): Observable<boolean> {
    return this.isVisiblePanelDetailTerritories$.asObservable();
  }

  setVisiblePanelEditTerritories(resp){
    this.isVisiblePanelEditTerritories$.next(resp);
  }

  getVisiblePanelEditTerritories(): Observable<boolean> {
    return this.isVisiblePanelEditTerritories$.asObservable();
  }

  setLoading(resp) {
    this.isLoading$.next(resp);
  }

  getLoading() {
    return this.isLoading$.asObservable();
  }

  getList(): any {}

  findByIdentifier(identifier): any {}

  getAllTerritoriesGeoJson(): any {}
}
